module.exports = __webpack_public_path__ + "img/222.e7122d3e.jpg";